import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const WS_BASE = BACKEND_URL.replace(/^http/, "ws") + "/api";

export const TOKEN_KEY = "pm_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({ baseURL: API_BASE, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function apiErrorMessage(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errMsg = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail != null) return apiErrorMessage(detail);
  if (e?.message) return e.message;
  return "Something went wrong. Please try again.";
};

export const fileUrl = (fileId) =>
  fileId ? `${API_BASE}/files/${fileId}?auth=${encodeURIComponent(getToken() || "")}` : null;

export const avatarSrc = (u) => {
  if (!u) return null;
  if (u.picture && /^https?:/.test(u.picture)) return u.picture;
  if (u.picture_file_id) return fileUrl(u.picture_file_id);
  return null;
};

export default api;
